import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

const EMPTY_CART_TEXT_EN = 'Your cart is empty';
const EMPTY_CART_TEXT_IT = 'Il tuo carrello è vuoto';

function localizeKachingEmptyCart(root = document) {
  const emptyState = root.querySelector('.kaching-cart__empty-cart-title');
  if (emptyState && emptyState.textContent?.trim() === EMPTY_CART_TEXT_EN) {
    emptyState.textContent = EMPTY_CART_TEXT_IT;
  }
}

function observeKachingEmptyCart() {
  localizeKachingEmptyCart();

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'childList') {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== Node.ELEMENT_NODE) continue;
          localizeKachingEmptyCart(node);
        }
      }

      if (mutation.type === 'characterData') {
        const parent = mutation.target.parentElement;
        if (parent?.classList.contains('kaching-cart__empty-cart-title')) {
          localizeKachingEmptyCart(parent);
        }
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
  });
}

observeKachingEmptyCart();

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
